













import { Component, Vue, Prop } from 'vue-property-decorator';
import TextCom from './text.vue';
import { Text } from '@/types/index';

@Component({
  components: {
    TextCom,
  },
})
export default class TextWrapper extends Vue {
  /** 如对某段文案有特殊颜色及字体需求，传入格式需如 以WeChat Pay HK消費均享{8%|#FA5151|PingFang HK}回贈 */
  @Prop() text!: string;

  /** 格式化后的字符串数组 */
  get textArr() {
    return this.getformatTextArr(this.text);
  }

  get htmlTmp() {
    return this.getRenderHtml(this.textArr);
  }

  /**
   * 输出拼接后的html字符串
   */
  public getRenderHtml(textArr: Text[]) {
    let template = '';
    textArr.forEach((text) => {
      const temp = `<span style="color:${text.color};font-family: ${text.font}">${text.text}</span>`;
      template = template.concat(temp);
    });
    return template;
  }

  /**
   * 传入的originText应为 '以{WeChat Pay HK|#07C160}消費均享{8%|#f8626|PingFang HK}回贈'格式
   */
  public getformatTextArr(originText: string): Text[] {
    const reg = /[{}]/;
    // 正则分割后再过滤数组的空值
    const strArr = originText.split(reg).filter((str) => {
      return !!str;
    });
    const textArr = strArr.map((str) => {
      // 固定格式为文案|颜色值|字体
      const arr = str.split('|');
      const [text = '', color = '', font = ''] = arr;
      return {
        text,
        color,
        font,
      };
    });
    return textArr;
  }
}
